module.exports = __webpack_public_path__ + "static/media/Triangle.8b961671.svg";